import type { FoodProfilesAction, FoodProfilesState } from './types'
import { FoodProfilesActionTypes } from './types'

export const initialFoodProfilesState: FoodProfilesState = {
  foodProfiles: [],
  loading: true,
  error: null
}

export function foodProfilesReducer(state: FoodProfilesState, action: FoodProfilesAction): FoodProfilesState {
  switch (action.type) {
    case FoodProfilesActionTypes.SET_FOOD_PROFILES:
      return {
        ...state,
        foodProfiles: action.payload,
        loading: false,
        error: null
      }
    case FoodProfilesActionTypes.SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case FoodProfilesActionTypes.CLEAR:
      return { ...initialFoodProfilesState }
    default:
      return state
  }
}
